module.exports = __webpack_public_path__ + "img/CObyVA.5470578a.svg";